import styled, { css } from 'styled-components'
import Form from 'components/Form'

export const StyledForm = styled(Form)`
  margin-top: 24px;
`

export const NewPasswordCaption = styled.span(
  ({ theme }) => css`
    display: block;
    font-size: ${theme.fontSizes.little};
    color: ${theme.colors.foreground.secondary[4]};
    margin-top: 4px;
  `
)
